import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const names = ['María García', 'Ana Rodríguez', 'Valentina López', 'Camila Fernández', 'Lucía Martínez', 'Carolina Ruiz', 'Sofía Herrera', 'Paula Morales', 'Daniela Torres', 'Gabriela Sánchez'];
const cities = ['Buenos Aires', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Quito', 'Medellín', 'Córdoba', 'Guadalajara', 'Rosario', 'Caracas', 'San José'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay — 30 seconds
    const initialTimeout = setTimeout(showPopup, 30000);
    // Repeat every 30-38 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        const delay = Math.random() * 8000 + 30000;
        setTimeout(showPopup, delay);
      }
    }, 38000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-97">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-lg border-l-4 border-blue-800 p-4 max-w-xs flex items-center gap-3" data-id="element-98">
          <div className="bg-blue-100 p-2 rounded-full" data-id="element-99">
            <ShoppingCartIcon className="w-5 h-5 text-blue-900" data-id="element-100" />
          </div>
          <div data-id="element-101">
            <p className="text-sm font-medium text-gray-900" data-id="element-102">
              {data.name} de {data.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-103">
              acaba de comprar este libro digital
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}